export const SCREEN_NAME = 'applications';

// searchQuery
export const SEARCH_QUERY = 'searchQuery';

export const TABLE_SETTINGS = 'tableSettings';

// columns
export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_STATUS = 'status';
export const COLUMN_INACTIVITY_PERIOD = 'inactivityPeriodDays';
export const COLUMN_IMPRESSION_ATTRIBUTION = 'impressionPeriodDays';
export const COLUMN_CLICK_ATTRIBUTION = 'clickPeriodDays';
export const COLUMN_DAYS_BETWEEN_REMARKETING = 'recurringRemarketingPeriodDays';
export const COLUMN_TRACK_RE = 'defaultTrackRe';
export const FILTER_STATUSES = 'statuses';
export const PERMISSION_ACTION_EDIT_APPLICATIONS = 44;
